!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : (e = e || self).Collapse = t(e.React);
}(this, function (e) {
  "use strict";

  function t(e, t) {
    for (var n = 0; n < t.length; n++) {
      var o = t[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }

  function n(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function o() {
    return (o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }

      return e;
    }).apply(this, arguments);
  }

  function r(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      t && (o = o.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, o);
    }

    return n;
  }

  function a(e) {
    return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function i(e, t) {
    return (i = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function s(e, t) {
    if (null == e) return {};

    var n,
        o,
        r = function (e, t) {
      if (null == e) return {};
      var n,
          o,
          r = {},
          a = Object.keys(e);

      for (o = 0; o < a.length; o++) n = a[o], t.indexOf(n) >= 0 || (r[n] = e[n]);

      return r;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (o = 0; o < a.length; o++) n = a[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }

    return r;
  }

  function l(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  e = e && e.hasOwnProperty("default") ? e.default : e;

  var c = "collapsed",
      p = "collapsing",
      u = "expanding",
      f = "expanded",
      h = function (h) {
    function g() {
      var e, t;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, g);

      for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) i[s] = arguments[s];

      return t = function (e, t) {
        return !t || "object" != typeof t && "function" != typeof t ? l(e) : t;
      }(this, (e = a(g)).call.apply(e, [this].concat(i))), n(l(t), "state", {
        collapseState: t.props.isOpen ? f : c,
        collapseStyle: {
          height: t.props.isOpen ? null : b(t.props),
          visibility: t.props.isOpen ? null : d(t.props)
        }
      }), n(l(t), "onTransitionEnd", function (e) {
        var n = e.target,
            o = e.propertyName;
        if (n === t.content && "height" === o) switch (t.state.collapseState, n.style.height, t.state.collapseState) {
          case u:
            "0px" === n.style.height || t.setState({
              collapseState: f
            });
            break;

          case p:
            "0px" !== n.style.height ? "onTransitionEnd height unexpected ".concat(n.style.height) : t.setState({
              collapseState: c
            });
            break;

          default:
            t.state.collapseState;
        }
      }), n(l(t), "getHeight", function () {
        return "".concat(t.content.scrollHeight, "px");
      }), n(l(t), "onCallback", function (e) {
        var o;
        e && e(function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var o = null != arguments[t] ? arguments[t] : {};
            t % 2 ? r(o, !0).forEach(function (t) {
              n(e, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : r(o).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
            });
          }

          return e;
        }({}, t.state, {
          isMoving: (o = t.state.collapseState, o === u || o === p)
        }));
      }), n(l(t), "setCollapsed", function () {
        t.content && t.setState({
          collapseStyle: {
            height: b(t.props),
            visibility: d(t.props)
          }
        }, function () {
          return t.onCallback(t.props.onChange);
        });
      }), n(l(t), "setCollapsing", function () {
        if (t.content) {
          var e = t.getHeight();
          t.setState({
            collapseStyle: {
              height: e,
              visibility: ""
            }
          }), y(function () {
            t.setState({
              collapseStyle: {
                height: b(t.props),
                visibility: ""
              }
            }, function () {
              return t.onCallback(t.props.onChange);
            });
          });
        }
      }), n(l(t), "setExpanding", function () {
        y(function () {
          if (t.content) {
            var e = t.getHeight();
            t.setState({
              collapseStyle: {
                height: e,
                visibility: ""
              }
            }, function () {
              return t.onCallback(t.props.onChange);
            });
          }
        });
      }), n(l(t), "setExpanded", function () {
        t.content && t.setState({
          collapseStyle: {
            height: "",
            visibility: ""
          }
        }, function () {
          return t.onCallback(t.props.onChange);
        });
      }), t;
    }

    var O, v, S;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && i(e, t);
    }(g, e.Component), O = g, S = [{
      key: "getDerivedStateFromProps",
      value: function (e, t) {
        var n = t.collapseState === f || t.collapseState === u;
        return !n && e.isOpen ? {
          collapseState: e.noAnim ? f : u
        } : n && !e.isOpen ? {
          collapseState: e.noAnim ? c : p
        } : null;
      }
    }], (v = [{
      key: "render",
      value: function () {
        var t = this,
            n = this.props,
            r = n.className,
            a = n.addState,
            i = n.children,
            l = n.transition,
            c = n.style,
            p = n.render,
            u = n.elementType,
            h = (n.noAnim, n.overflowOnExpanded),
            y = (n.collapseHeight, n.onInit, n.onChange, n.isOpen, s(n, ["className", "addState", "children", "transition", "style", "render", "elementType", "noAnim", "overflowOnExpanded", "collapseHeight", "onInit", "onChange", "isOpen"])),
            b = {
          overflow: this.state.collapseState === f && h ? "" : "hidden",
          transition: l
        };
        Object.assign(b, c), Object.assign(b, this.state.collapseStyle);
        var d = u || "div",
            g = a ? "".concat(r, " --c-").concat(this.state.collapseState) : r;
        return e.createElement(d, o({
          ref: function (e) {
            t.content = e;
          },
          style: b,
          className: g,
          onTransitionEnd: this.onTransitionEnd
        }, y), "function" == typeof i ? i(this.state.collapseState) : "function" == typeof p ? p(this.state.collapseState) : i);
      }
    }, {
      key: "componentDidMount",
      value: function () {
        this.onCallback(this.props.onInit);
      }
    }, {
      key: "componentDidUpdate",
      value: function (e, t) {
        if (this.content && this.state.collapseState !== t.collapseState) switch (this.state.collapseState) {
          case u:
            this.setExpanding();
            break;

          case p:
            this.setCollapsing();
            break;

          case f:
            this.setExpanded();
            break;

          case c:
            this.setCollapsed();
        }
      }
    }]) && t(O.prototype, v), S && t(O, S), g;
  }();

  function y(e) {
    requestAnimationFrame(function () {
      return requestAnimationFrame(e);
    });
  }

  function b(e) {
    return e.collapseHeight || "0px";
  }

  function d(e) {
    return e.collapseHeight ? "" : "hidden";
  }

  return n(h, "defaultProps", {
    style: {}
  }), h;
});